
import { createStyles } from '@material-ui/core';
import { UNIT } from '../../constants/theme';
export const styles = createStyles({
    viewStyle: {
        borderRadius: UNIT
    },
    banner: {
        display: 'inline-block',
        margin: '0 4px',
        padding: '2px 8px',
        borderRadius: '4px',
        border: '1px solid rgba(0, 153, 115, 0.5)',
        backgroundColor: 'rgba(0, 153, 115, 0.1)',
        fontWeight: 'bold',
        color: 'rgba(0, 153, 115, 1)'
    }
});